export default function () {
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.8
    };

    let callback = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
                entry.target.play();
            } else {
                entry.target.pause();
            }
        });
    };

    let observer = new IntersectionObserver(callback, options);
    const videos = document.querySelectorAll('video');

    videos.forEach(video => {
        observer.observe(video);
    });
}
